import coreAPI from 'apis/core';

export const checkUsernameExist = async (username) => {
  if (!username) return null;
  const response = await coreAPI.user.checkUsernameExist(username);

  return response.data;
};

export const getUserById = async (userId) => {
  if (!userId) throw new Error('Invalid request: user not provided');

  const response = await coreAPI.user.getUserById(userId);
  return response.user;
};

export const updateUserById = async (userId, payload) => {
  if (!userId) throw new Error('Invalid request: user not provided');
  if (!payload) throw new Error('Invalid request: payload not provided');

  const response = await coreAPI.user.updateUserById({ userId, payload });
  return response.data[0];
};

export const getUserClinicsByUserId = async (params) => {
  const response = await coreAPI.user.getUserClinicsByUserId(params);

  return response.clinics;
};

export default {};
